import React from "react";

function MusicAddIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="28"
      viewBox="0 0 27 28"
    >
      <g
        id="Group_25516"
        data-name="Group 25516"
        transform="translate(0.341 0.297)"
      >
        <g id="Group_25514" data-name="Group 25514" transform="translate(0 0)">
          <ellipse
            id="Ellipse_2005"
            data-name="Ellipse 2005"
            cx="13.5"
            cy="14"
            rx="13.5"
            ry="14"
            transform="translate(-0.341 -0.297)"
            fill="#181818"
          />
        </g>
        <path
          id="Path_18459"
          data-name="Path 18459"
          d="M10.95,10.95V5h1.983v5.95h5.95v1.983h-5.95v5.95H10.95v-5.95H5V10.95Z"
          transform="translate(0.905 1.892)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default MusicAddIcon;
